import './meetings.less';

angular.module("tromanWeb").controller('RootMeetingsController', ['systemInfo', 'meetingsShared', function (systemInfo, meetingsShared) {

    this.isPolitikerEnabled = systemInfo.IsPolitikerEnabled;

    this.getAddId = function getAddId() {
        return meetingsShared.getAddId();
    };
}]);
